import React from 'react';
import './PoseGuide.css';

export function PoseGuide() {
  return (
    <div id="pose-guide" className="pose-guide" tabIndex={-1}>
      <h5 className="pose-guide__title">정밀한 자세 분석을 위한 촬영 가이드</h5>
      <div className="pose-guide__grid">
        <div className="pose-guide__card">
          <div className="pose-guide__num">01</div>
          <div>
            <strong className="pose-guide__heading">측면 3~4m 거리</strong>
            <p className="pose-guide__text">
              체험자의 머리부터 발끝까지 전신이 카메라 프레임 안에 완전히 들어와야 합니다.
            </p>
          </div>
        </div>

        <div className="pose-guide__card">
          <div className="pose-guide__num">02</div>
          <div>
            <strong className="pose-guide__heading">렌즈 높이 허리~가슴</strong>
            <p className="pose-guide__text">
              카메라를 지면과 수평으로 설치하면 원근 왜곡 없이 관절 각도가 정확해집니다.
            </p>
          </div>
        </div>

        <div className="pose-guide__card">
          <div className="pose-guide__num">03</div>
          <div>
            <strong className="pose-guide__heading">역광 방지 및 균일한 조명</strong>
            <p className="pose-guide__text">
              등 뒤통수 방향의 강한 역광을 피하고 단색 배경에서 인식률이 가장 높습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
